import React from 'react';

function TrackHover(Component) {
  return class Hoverable extends React.Component {
    state = {
      isHovered: false,
    };

    setIsHovered(isHovered) {
      this.setState({
        isHovered,
      });
    }

    render() {
      return (
        <div
          onMouseOver={() => this.setIsHovered(true)}
          onMouseOut={() => this.setIsHovered(false)}
        >
          <Component {...this.props} isHovered={this.state.isHovered} />
        </div>
      );
    }
  };
}

export default TrackHover;



// WEBPACK FOOTER //
// ./src/utils/TrackHover.js